<template>
  <v-dialog v-model="dialog" max-width="850" scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-card
        class="mx-auto pa-5 h-100 rounded-lg"
        v-on="on"
        v-bind="attrs"
        outlined
        hover
        min-height="200"
      >
        <v-card-text>
          <v-row>
            <v-col xl="7" lg="7" md="7" sm="12" cols="12">
              <p class="title font-weight-bold black--text mb-1">
                {{ convenio.empresa }}
              </p>
              <p>{{ convenio.tipo }}</p>
            </v-col>
            <v-col xl="5" lg="5" md="5" sm="12" cols="12" align-self="center">
              <v-img
                :src="getImage()"
                contain
                max-width="200"
                max-height="100"
              ></v-img>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn
            @click.stop
            min-width="65"
            rounded
            outlined
            small
            color="secondary"
            target="blank"
            :href="convenio.site"
          >
            Site
          </v-btn>
          <v-btn
            v-if="convenio.contato != ''"
            outlined
            small
            rounded
            color="teal"
            @click.stop="abrirWhats(convenio)"
            ><v-icon small left>mdi-whatsapp</v-icon>Whatsapp</v-btn
          >
        </v-card-actions>
      </v-card>
    </template>
    <v-card :loading="carregando">
      <v-card-title class="green lighten-4 primary--text font-weight-bold">{{
        convenio.empresa
      }}</v-card-title>
      <v-card-subtitle class="green lighten-4 primary--text caption">{{
        convenio.tipo
      }}</v-card-subtitle>
      <v-card-text class="pt-5" v-html="conteudo"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn rounded @click="dialog = false" color="secondary" small
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { getToken } from "@/global";

export default {
  props: {
    convenio: Object,
  },
  watch: {
    dialog: async function (open) {
      if (open) {
        await this.getConteudoConvenio();
      }
    },
  },
  data: () => ({
    dialog: false,
    conteudo: "",
    carregando: false,
  }),
  methods: {
    abrirWhats(value) {
      window.open(
        `https://wa.me/55${value.contato}?text=Olá, trabalho na Coasul e gostaria de saber mais informações sobre o convênio para os colaboradores...`,
        "_blank"
      );
    },
    getImage() {
      return `${
        process.env.VUE_APP_BASE_URL
      }/colaborador/convenios?funcao=LOGOTIPO&id=${
        this.convenio.codigo
      }&token=${getToken()}`;
    },
    async getConteudoConvenio() {
      this.conteudo = "";
      this.carregando = true;
      await axios
        .get(
          `/colaborador/convenios?funcao=VISUALIZAR&id=${this.convenio.codigo}`
        )
        .then((res) => {
          this.conteudo = res.data;
        })
        .catch((e) => this.$toasted.error(e));
      this.carregando = false;
    },
  },
};
</script>

<style>
p {
  margin-bottom: 2px !important;
}
</style>


